window.renderBundleDataCollection = function(bundle, container) {

	const bundleItemTemplate = (title, quantity, price, originalPrice, optionName, handle, hasOnlyDefaultVariant, checked) => `
	<li>
		<input class="siticy-atck-bundles__radio" id="${handle}-bundle-radio-${quantity}" type="radio" name="${handle}-bundle" ${checked ? 'checked' : ''} value="${quantity}">
		<div>
		<label class="siticy-atck-bundles__label" for="${handle}-bundle-radio-${quantity}">
		<div>${title}</div>
		<span>
			<b>${price}</b>
			<s>${originalPrice}</s>
		</span>
		</label>
		<div class="siticy-atck-bundles__choices ${ hasOnlyDefaultVariant ? 'hidden' : '' }">
		<label class="siticy-atck-bundles__variants" for="${handle}-siticy-atck-bundles__variants-${quantity}">Pick your ${optionName}</label>
		<input id="${handle}-siticy-atck-bundles__variants-${quantity}" type="checkbox"/>
		</div>
		</div>
	</li>
	`;

	const bundlesContainer = document.querySelector(container);

	let allBundlesHTMLstring = '';

	for (const bundleItem in bundle) {
		const { title, quantity, price, originalPrice, optionName, handle, hasOnlyDefaultVariant, checked } = bundle[bundleItem];
		const bundleItemsHTMLstring = bundleItemTemplate(title, quantity, price, originalPrice, optionName, handle, hasOnlyDefaultVariant, checked);
		allBundlesHTMLstring += bundleItemsHTMLstring;
	}

	bundlesContainer.innerHTML = allBundlesHTMLstring;

}

window.triggerATC = function (id, bundle = null) {
	if ( bundle == null ) {
		window.sideCart.addProductOpen(id)
	} else {
		window.sideCart.addBundle(id, () => {
			fetch('https://api.fastbundle.co/v1/carts/bundles/', {
				body: JSON.stringify({
					bundle: bundle.id,
					bundle_variants: [],
					click_from_page_type: "product",
					click_from_url: bundle.handle,
					shop: "madamsew.myshopify.com",
					show_uuid: bundle.uuid,
					token: "72ffe26a58c33af66cbb34bc4537a5a2",
					user_ip: ""
				}),
				credentials: 'same-origin',
				headers: {
				'Content-Type': 'application/json',
				'X-Requested-With':'xmlhttprequest'
				},
				method: 'POST'
			}).then((response) => {
				return response.json();
			}).then((json) => {
		
				fetch('/cart/update.js', {
					body: JSON.stringify({
						attributes: {
							'Bundle id': json.cart_discount_id
						}
					}),
					credentials: 'same-origin',
					headers: {
					'Content-Type': 'application/json',
					'X-Requested-With':'xmlhttprequest'
					},
					method: 'POST'
				}).then((response) => {
					return response.json();
				}).then(() => {

					setTimeout(() => {
						window.sideCart.cartOpen()
					}, 1000);

				}).catch((err) => console.error(err));
			}).catch((err) => console.error(err));
		})
	}

	document.querySelectorAll('.sticky-atc--plp').forEach(item => {
		item.classList.remove('sticky-atc--enabled');
	})
}


document.addEventListener('click', event => {

	if (event.target.matches('.sticky-atc-overlay')) {
		document.querySelector('.sticky-atc-overlay').classList.remove('sticky-atc-overlay--active');

		document.querySelectorAll('.sticky-atc--plp').forEach(item => {
			item.classList.remove('sticky-atc--enabled');
		});
	}

	if (event.target.matches('.plp-atc-trigger')) {
		event.preventDefault();

		if (event.target.classList.contains('set-bundle') && !event.target.classList.contains('dev-desktop')) {
			setBYOBProductsAdds();
			localStorage.setItem('set-bundle', true);
		}
		
		if ( event.target.dataset.hasOptions == "false") {
			const variantId = event.target.dataset.variant;
			triggerATC(variantId)
		} else {
			event.target.parentElement.querySelector('.sticky-atc--plp').classList.add('sticky-atc--enabled');
			if (window.innerWidth < 750) {
				document.querySelector('.sticky-atc-overlay').classList.add('sticky-atc-overlay--active');
			}
		}

	}

	if (event.target.matches('.sticky-atc-variants__switch')) {
		event.preventDefault();
		event.target.classList.toggle('sticky-atc-variants__switch--active');
	}

	if (event.target.matches('.sticky-atc-variants__switch-item')) {
		event.target.parentElement.parentElement.classList.remove('sticky-atc-variants__switch--active')
	}

	if (event.target.matches('.siticy-atck-bundles__variants')) {

		const bundleReference = event.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
		const bundleNodes = bundleReference.querySelectorAll('.siticy-atck-bundles__radio');
		const bundleMax = bundleNodes[bundleNodes.length- 1].value;
  
		if (event.target.nextElementSibling.checked) {
		  // Show bundles
		  event.target.parentElement.parentElement.parentElement.parentElement.querySelectorAll('li').forEach(item => item.classList.remove('active','current'));
		} else {
		  const stickyVariantOptions = bundleReference.querySelector('.sticky-atc-variants');
		  event.target.parentElement.append(stickyVariantOptions);
		  // Hide bundles
		  event.target.parentElement.parentElement.parentElement.parentElement.querySelectorAll('li').forEach(item => item.classList.add('active'));
		  event.target.parentElement.parentElement.parentElement.classList.add('current')
		}
  
  
		const bundleLimit = bundleReference.querySelector('.siticy-atck-bundles__radio:checked').value;
		const bundleOptions = bundleReference.querySelectorAll('.sticky-atc-variants__item');
		bundleOptions.forEach(option => option.classList.remove('sticky-atc-variants__item--enabled'))
  
		for (let i = 0; i < bundleMax; i++) {
		  bundleOptions[i].classList.add('sticky-atc-variants__item--available');
		}
  
		for (let i = 0; i < bundleLimit; i++) {
		  bundleOptions[i].classList.add('sticky-atc-variants__item--enabled');
		}
  
	}

	if (event.target.matches('.siticy-atck-button')) {
		event.preventDefault();

		const bundleReference = event.target.parentElement;
		const stickyType = bundleReference.querySelector('input.sticky-atc-type__radio:checked').value;


		if(stickyType == 'single') {

			const variantId = bundleReference.querySelector('.sticky-atc-single__data input:checked').value;
			triggerATC(variantId)


		} else {

			if (bundleReference.dataset.type == 'unique') {

				triggerATC(
					[{
						id: bundleReference.dataset.variant,
						quantity: bundleReference.querySelector('.siticy-atck-bundles__radio:checked').value
					}],
				{
					id: bundleReference.dataset.bundleId,
					uuid: bundleReference.dataset.bundleUuid,
					handle: bundleReference.dataset.handle
				});

			} else {

				let bundleItems = [];
				bundleReference.querySelectorAll('.siticy-atck-bundles .sticky-atc-variants__item--enabled input:checked').forEach(option => {
				    const bundleItem = bundleItems.find(item => item.id == option.value);
				    if (bundleItem) {
				        bundleItem.quantity += 1;
				    } else {
				        bundleItems.push({
				            quantity: 1, id: option.value
				        })
				    }
				})

				//console.log("bundleItems ===========", bundleItems);
				triggerATC(bundleItems,
				{
					id: bundleReference.dataset.bundleId,
					uuid: bundleReference.dataset.bundleUuid,
					handle: bundleReference.dataset.handle
				});

			}
		}
	}

});


document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.qty-input').forEach((element) => {
		const input = element.querySelector('.qty-input__value');
		const decreaseBtn = element.querySelector('.qty-input__button--decrease');
		const increaseBtn = element.querySelector('.qty-input__button--increase');
		
		decreaseBtn.addEventListener('click', () => {
			parseInt(input.value) > 1 ? input.value = parseInt(input.value) - 1 : 0;
		});
		
		increaseBtn.addEventListener('click', () => {
			input.value = parseInt(input.value) + 1;
		});
	});
});
